import { z } from 'zod';
import { BasicQuery, EntityReference } from './webapp-common.dto';

const Degradation = z
  .object({
    value: z.number(),
    rate: z.number(),
  })
  .nullable();

export const Job = z.object({
  id: z.string(),
  prId: z.string(),
  startedAt: z.coerce.date(),
  endedAt: z.coerce.date().nullable(),
  // tests data not really needed for now but might be used in the future
  totalTests: z.number().nullable(), 
  failedTests: z.number().nullable(),
  degradedEndpoints: z.number(),
  baseP90Duration: z.number().nullable(),
  baseP50Duration: z.number().nullable(),
  topDegradedEndpoint: EntityReference.nullable(),
  topDegradedEndpointService: EntityReference.nullable(),
  p90Degradation: Degradation,
  p50Degradation: Degradation,
  architecture: z.string(),
});

export type Job = z.infer<typeof Job>;

const degradationSortableKeys = {
  'p90Degradation.rate': z.string(),
  'p90Degradation.value': z.string(),
};
export const JobSortableKeys = Job.omit({
  p90Degradation: true,
  p50Degradation: true,
})
  .extend(degradationSortableKeys)
  .keyof();

export type JobSortableKeys = z.infer<typeof JobSortableKeys>;

export const GetJobsQuery = BasicQuery.extend({
  orderBy: z
    .object({
      key: JobSortableKeys,
      sortOrder: z.union([z.literal('asc'), z.literal('desc')]),
    })
    .optional(),
  onlyShowDegraded: z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .transform((value) => value === true || value === 'true')
    .optional(),
});

export type GetJobsQuery = z.infer<typeof GetJobsQuery>;

export const GetJobsResponse = z.object({
  total: z.number(),
  countFiltered: z.number(),
  jobs: z.array(Job),
});

export type GetJobsResponse = z.infer<typeof GetJobsResponse>;

export const JobEndpoint = z.object({
  serviceId: z.number(),
  serviceName: z.string(),
  
  id: z.number(),
  path: z.string(),

  degraded: z.boolean(),

  runs: z.number(),
  p90: z.number(),
  p50: z.number(),
  p90Degradation: Degradation,
  p50Degradation: Degradation,
  errorRate: z.number(),
  p90_duration_base: z.number(),
  p50_duration_base: z.number(),
});

export type JobEndpoint = z.infer<typeof JobEndpoint>;

export const GetJobQuery = BasicQuery.pick({
  environmentName: true,
});

export type GetJobQuery = z.infer<typeof GetJobQuery>;

export const GetJobResponse = z.object({
  job: Job,
  endpoints: z.array(JobEndpoint),
});

export type GetJobResponse = z.infer<typeof GetJobResponse>;
